import React, { useEffect } from 'react';
import { X } from 'lucide-react';

/*
 * Fechar uma janela é a ação mais repetida do sistema — e era a pior de
 * acertar. Os "X" tinham 28×28 e 32×32 pixels, contra os 44×44 que as
 * diretrizes de toque recomendam, e ficavam no canto onde o polegar é menos
 * preciso. Funcionavam; só era difícil acertá-los.
 *
 * Aqui ficam as duas peças, uma vez só: o botão com alvo grande e o atalho
 * de teclado. Duplicá-las nas oito janelas do sistema seria repetir o erro
 * que causou o bug das datas D-1.
 */

/** Fecha a janela com Esc — comportamento que todo modal deveria ter. */
export function useEscFecha(onClose) {
  useEffect(() => {
    if (!onClose) return undefined;
    const aoTeclar = (e) => { if (e.key === 'Escape') { e.stopPropagation(); onClose(); } };
    document.addEventListener('keydown', aoTeclar);
    return () => document.removeEventListener('keydown', aoTeclar);
  }, [onClose]);
}

/**
 * Botão de fechar com alvo de 44×44 px.
 *
 * `type="button"` é explícito de propósito: sem ele, um botão que caia dentro
 * de um <form> vira submit por padrão — e fechar a janela passaria a salvar
 * o formulário. Já esteve a um refactor de distância de acontecer.
 *
 * `tom="claro"` para cabeçalhos coloridos, `tom="neutro"` para fundo branco.
 */
export default function BotaoFechar({ onClose, tom = 'neutro', className = '', testid = 'fechar' }) {
  const cores = tom === 'claro'
    ? 'text-white hover:bg-white/20 focus-visible:ring-white/60'
    : 'text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 focus-visible:ring-indigo-500';
  return (
    <button
      type="button"
      onClick={onClose}
      aria-label="Fechar"
      title="Fechar (Esc)"
      data-testid={testid}
      className={`shrink-0 w-11 h-11 -m-1.5 flex items-center justify-center rounded-lg transition-colors
                  focus:outline-none focus-visible:ring-2 ${cores} ${className}`}
    >
      <X className="w-5 h-5" />
    </button>
  );
}
